import '@fancyapps/fancybox';
const $ = jQuery.noConflict();

'use strict';
const QuoteFormValidation = {
	/**
	 * @description Cache DOM elements and strings
	 * @type {object}
	 */
	$form: $('.js-quote-request-form'),
	$popup: $('.js-popup-quote-request'),
	$requiredFields: null,
	$submitButton: null,
	classError: 'error',
	classErrorMessage: 'error-message',
	classDisabled: 'btn-inactive',
	$ajaxResponseContainer: $('.js-quote-form-response'),


	/** @description Initialize */
	init: function() {
		this.cacheDOM();
		this.bindEvents();
		this.updateSubmitButtonState(); // Initial validation check
	},

	/** @description Cache DOM elements */
	cacheDOM: function() {
		this.$requiredFields = this.$form.find('[required], [data-required]');
		this.$submitButton = this.$form.find('.js-quote-request-form-submit-btn');
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$form.on('submit', QuoteFormValidation.handleSubmit);
		this.$requiredFields.on('input change', this.handleFieldChange.bind(this));
	},

	/**
	 * @description Handle form submission
	 * @param {Event} e - The form submission event
	 */
	handleSubmit: function(e) {
		let isValid = true;
		let $firstInvalidField = null;

		QuoteFormValidation.$requiredFields.each((_, field) => {
			const $field = $(field);
			if (!QuoteFormValidation.validateField(null, $field)) {
				isValid = false;
				// Store the first invalid field
				if (!$firstInvalidField) {
					$firstInvalidField = $field;
				}
			}
		});

		// scroll to the first invalid field
		if (!isValid) {
			if ($firstInvalidField) {
				QuoteFormValidation.scrollToField($firstInvalidField);
			}
			return;
		}

		// submit
		QuoteFormValidation.sendRequest();
		e.preventDefault(); // Prevent form submission
	},

	/**
	 * @description Scroll smoothly to a field within the popup
	 * @param {jQuery} $field - The field to scroll to
	 */
	scrollToField: function($field) {
		const popupContent = this.$form.closest('.js-popup');

		if (popupContent.length) {
			// Scroll inside the popup
			popupContent.animate({
				scrollTop: $field.offset().top - popupContent.offset().top + popupContent.scrollTop() - 20,
			}, 300); // Adjust offset as needed
		} else {
			// Scroll on the main page (fallback)
			$('html, body').animate({
				scrollTop: $field.offset().top - 20,
			}, 300); // Adjust offset as needed
		}

		// Optionally focus on the field after scrolling
		$field.focus();
	},


	/**
	 * @description Handle field change events and update button state
	 * @param {Event} e - The input/change event
	 */
	handleFieldChange: function(e) {
		const $field = $(e.target);
		this.validateField(e, $field);
		this.updateSubmitButtonState();
	},


	/**
	 * @description Validate individual field
	 * @param {Event} e - The input/change event
	 * @param {jQuery} $field - The field to validate
	 * @returns {boolean} Whether the field is valid
	 */
	validateField: function(e, $field) {
		$field = $field || $(e.target); // Handle both event and direct calls
		const errorMessage = $field.data('error-message') || 'This field is required.';
		let isValid = true;

		if ($field.val().trim() === '' || ($field.attr('type') === 'radio' && !this.isRadioChecked($field))) {
			this.showError($field, errorMessage);
			isValid = false;
		} else {
			this.clearError($field);
		}

		return isValid;
	},


	/**
	 * @description Check if at least one radio button in a group is checked
	 * @param {jQuery} $field - The radio field to check
	 * @returns {boolean} Whether a radio is checked
	 */
	isRadioChecked: function($field) {
		const group = this.$form.find(`input[name="${$field.attr('name')}"]`);
		return group.is(':checked');
	},


	/**
	 * @description Show an error message for a field
	 * @param {jQuery} $field - The field with an error
	 * @param {string} message - The error message to display
	 */
	showError: function($field, message) {
		let $errorElement = $field.siblings(`.${this.classErrorMessage}`);

		if (!$errorElement.length) {
			$errorElement = $(`<span class="${this.classErrorMessage}"></span>`);
			$field.closest('.quote-request__form-field').append($errorElement);
		}

		$errorElement.html(message);
		$field.addClass(this.classError);
	},


	/**
	 * @description Clear the error message for a field
	 * @param {jQuery} $field - The field to clear the error for
	 */
	clearError: function($field) {
		const $errorElement = $field.siblings(`.${this.classErrorMessage}`);
		$errorElement.html('');
		$field.removeClass(this.classError);
	},


	/**
	 * @description Update the state of the submit button based on form validity
	 */
	updateSubmitButtonState: function() {
		let isFormValid = true;

		this.$requiredFields.each((_, field) => {
			const $field = $(field);
			if ($field.val().trim() === '' || ($field.attr('type') === 'radio' && !this.isRadioChecked($field))) {
				isFormValid = false;
			}
		});

		if (isFormValid) {
			this.$submitButton.removeAttr('disabled');
		} else {
			this.$submitButton.attr('disabled', 'disabled');
		}
		this.$submitButton.toggleClass(this.classDisabled, !isFormValid);
	},

	emptyFormFields: function() {
		$('.js-quote-form-type-of-coating').text('');
		$('.js-quote-form-substrates').text('');
		$('.js-quote-form-existing-coating').text('');
		$('.js-quote-form-features').text('');
		$('.js-quote-form-app-features').text('');
		$('.js-quote-form-certifications').text('');
		$('.js-quote-form-uv-stability').text('');
		$('.js-quote-form-products').text('');
		QuoteFormValidation.$form.find('input[name=area_size]').val('');
		QuoteFormValidation.$form.find('select[name=area_unit]').val('');
		QuoteFormValidation.$form.find('#select2-lifespan-container').attr('title', 'Select').text('Select');
		QuoteFormValidation.$form.find('input[name=project_location]').val('');
		QuoteFormValidation.$form.find('input[name=project_timeline]').val('');
		QuoteFormValidation.$form.find('input[name=first_name]').val('');
		QuoteFormValidation.$form.find('input[name=last_name]').val('');
		QuoteFormValidation.$form.find('input[name=company]').val('');
		QuoteFormValidation.$form.find('input[name=phone]').val('');
		QuoteFormValidation.$form.find('input[name=email]').val('');
		QuoteFormValidation.$form.find('#select2-timezone-container').attr('title', 'Select').text('Select');
		QuoteFormValidation.$form.find('.radio-list__radio-input').removeAttr('checked');
		QuoteFormValidation.$form.find('.radio-list__radio-input:checked + .radio-list__radio-circle').css({'border-color': '#e1e1f0', 'background-color': 'transparent'});
		QuoteFormValidation.$form.find('textarea[name=message]').val('');
	},

	sendRequest: function() {

		QuoteFormValidation.toggleSpinner(true);
		QuoteFormValidation.$ajaxResponseContainer.hide();
		const data = {
			action: 'fws-product-finder-quote',
			'finder_type_of_coating': $('.js-quote-form-type-of-coating').text(),
			'finder_substrates': $('.js-quote-form-substrates').text(),
			'finder_exist_coating': $('.js-quote-form-existing-coating').text(),
			'finder_features': $('.js-quote-form-features').text(),
			'finder_app_features': $('.js-quote-form-app-features').text(),
			'finder_certifications': $('.js-quote-form-certifications').text(),
			'finder_uv_stability': $('.js-quote-form-uv-stability').text(),
			'finder_products': $('.js-quote-form-products').text(),
			'area_size': QuoteFormValidation.$form.find('input[name=area_size]').val(),
			'area_unit': QuoteFormValidation.$form.find('select[name=area_unit]').val(),
			'lifespan': QuoteFormValidation.$form.find('select[name=lifespan]').val(),
			'project_location': QuoteFormValidation.$form.find('input[name=project_location]').val(),
			'project_timeline': QuoteFormValidation.$form.find('input[name=project_timeline]').val(),
			'first_name': QuoteFormValidation.$form.find('input[name=first_name]').val(),
			'last_name': QuoteFormValidation.$form.find('input[name=last_name]').val(),
			'company': QuoteFormValidation.$form.find('input[name=company]').val(),
			'phone': QuoteFormValidation.$form.find('input[name=phone]').val(),
			'email': QuoteFormValidation.$form.find('input[name=email]').val(),
			'timezone': QuoteFormValidation.$form.find('select[name=timezone]').val(),
			'time_callback': QuoteFormValidation.$form.find('input[name=time_callback]:checked').val(),
			'message': QuoteFormValidation.$form.find('textarea[name=message]').val(),
		};
		$.post({
			url: window.fwsLocalized.ajaxUrl,
			dataType: 'JSON',
			data: data,
			success: (response) => {
				if (response && response.success) {
					QuoteFormValidation.onAjaxSuccess(response);
				} else {
					QuoteFormValidation.onAjaxFailure(response);
				}
			},
			error: (jqXHR) => {
				let message = 'Something  went wrong.';
				if (jqXHR.responseText === '0' && jqXHR.status === 400) message = 'Something went wrong: unknown action.';
				QuoteFormValidation.onAjaxFailure({error: message});
			},
			complete: () => {
				QuoteFormValidation.toggleSpinner(false);
			}
		});
	},


	// handle success of adding to cart
	onAjaxSuccess: function() {
		// open the "Thank You" popup using Fancybox
		$.fancybox.open({
			src: $('.js-popup-thankyou'),
			type: 'inline', // Fancybox type
			smallBtn: true, // Small close button
		});

		// confirmation
		const html = '<p><span style="color:green">Quote inquiry sent successfilly.</span></p>';
		QuoteFormValidation.$ajaxResponseContainer.html(html).show();

		// hide form
		QuoteFormValidation.emptyFormFields();
		setTimeout(() => {
			$('.fancybox-container.fancybox-is-open').css({'display': 'none'});
			$('body').removeClass('fancybox-active compensate-for-scrollbar');
			$('.quote-request__form-validation-notes').css({'display': 'none'});
		}, 3000);
	},


	// handle soft-failure of adding to cart
	onAjaxFailure: function(response) {
		const message = (response && response.error) || 'Something went wrong.';
		const html = '<p><span class="add-error">' + message + '</span></p>';
		QuoteFormValidation.$ajaxResponseContainer.html(html).show();

		if (response.data && response.data.errors) {
			Object.entries(response.data.errors).forEach(([k, v]) => {
				const messages = v.map(e => e.message).join('<br>');
				const element = QuoteFormValidation.$form.find('[name='+k+']');
				QuoteFormValidation.showError(element, messages);
			});
		}
	},


	toggleSpinner(state) {
		QuoteFormValidation.$form.toggleClass('is-loading', state);
	}

};

export default QuoteFormValidation;
